import { Component, OnDestroy, OnInit } from "@angular/core";
import * as moment from "moment";
import { Subscription } from "rxjs";
import { map } from "rxjs/internal/operators/map";
import { ApiService } from "src/app/services/api/api.service";

@Component({
  selector: "app-transaction-history",
  templateUrl: "./transaction-history.component.html",
  styleUrls: ["./transaction-history.component.scss"],
})
export class TransactionHistoryComponent implements OnInit, OnDestroy {
  private transactionsHistoryList;

  private lastPage: number;
  private currentPageNumber: number;
  public totalItems: number = 0;

  private transactionsHistorySubscription: Subscription;

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    this.getTransactionsHistory();
  }

  getTransactionsHistory() {
    this.transactionsHistorySubscription = this.apiService
      .get("/profile/transactions")
      .subscribe((response) => {
        this.transactionsHistoryList = response.data.data;
        this.lastPage = response.data.last_page;
        this.currentPageNumber = response.data.current_page;
        this.totalItems = response.data.total;
      });
  }

  fPagination(pageNum: number | string, force: boolean = false) {
    if (pageNum !== this.currentPage || force) {
      this.transactionsHistorySubscription = this.apiService
        .get(`/profile/transactions?page=${pageNum}`)
        .pipe(map((response) => response))
        .subscribe((response) => {
          this.transactionsHistoryList = response.data.data;
          this.currentPageNumber = response.data.current_page;
          this.scrollToTop();
        });
    }
  }

  increaseCurrentPage() {
    if (this.currentPage < this.lastPage) {
      this.currentPageNumber++;
      this.fPagination(this.currentPageNumber, true);
      this.scrollToTop();
    }
  }

  decreaseCurrentPage() {
    if (this.currentPage > 1) {
      this.currentPageNumber--;
      this.fPagination(this.currentPageNumber, true);
      this.scrollToTop();
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  formatDate(date) {
    return moment(date).locale("ka").format(`M.D.yy`);
  }

  get transactionsHistoryListing() {
    return this.transactionsHistoryList;
  }

  get currentPage() {
    return this.currentPageNumber;
  }

  get total() {
    const data = [];
    for (let i = 1; i <= this.lastPage; i++) {
      data.push(i);
    }
    return data;
  }

  get getLastPage() {
    return this.lastPage;
  }

  ngOnDestroy() {
    if (this.transactionsHistorySubscription)
      this.transactionsHistorySubscription.unsubscribe();
  }
}
